import React from 'react';
import PropTypes from 'prop-types';
import styles from './PartnersComponent.module.css';
import '../styles/theme.css';

function PartnersComponent({ images }) {
  return (
    <section id="partners" className={styles['partners']}>
      <div className={styles['partners-inner']}>
        <h2 className={styles['partners-title']}>
          Our Team Has Worked With
        </h2>
        <div className={styles['grid']}>
          {images.slice(0, 8).map((src, i) => (
            <div key={i} className={styles['cell']}>
              <img
                src={src}
                alt=""
                className={styles['logo']}
                onError={(e) => {
                  if (!e.currentTarget.dataset.retried) {
                    e.currentTarget.dataset.retried = '1';
                    setTimeout(() => {
                      e.currentTarget.src = src + '?v=' + Date.now();
                    }, 200);
                  }
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

PartnersComponent.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PartnersComponent;
